import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FIXED_FOOTER_DIV_ID } from '../../components/Layout/MainLayout/MainLayout';

export const ContractRoute = ({ route, ...componentProps }) => {
  useEffect(() => {
    if (route.fixedFooter) {
      document.getElementById(FIXED_FOOTER_DIV_ID).style.display = 'flex';
    } else {
      document.getElementById(FIXED_FOOTER_DIV_ID).style.display = 'none';
    }
  }, [route.fixedFooter]);
  return <route.component {...componentProps} />;
};

ContractRoute.propTypes = {
  route: PropTypes.object,
};

